import { FormSchema } from 'UI/constants/entityTypes';
import { getInitials } from 'utils';

import { MINIMUM_WORD_LENGTH, PHRASES_TO_IGNORE } from './EditCandidateDataSheet.constants';

/**
 * @param {string} str
 */
export const normalizeString = str => str.toLowerCase().trim();

export const cleanLine = line => line.replace(/(?:•|●|- |❖|o\t||·|and )/g, '').trim();

/**
 * @param {string} line
 */
export const extractFromLine = line => {
  const parts = cleanLine(line).split(', ');
  return parts.filter(part => part.length >= MINIMUM_WORD_LENGTH);
};

/**
 * @param {string} experience
 */
export const filterOutIgnoredPhrases = experience => {
  const lowercaseExperience = normalizeString(experience);
  return !PHRASES_TO_IGNORE.some(phrase => lowercaseExperience.includes(phrase));
};

/**
 * @param {string[]} lines
 */
export const extractSkillsFromLines = lines => {
  const skills = [];
  lines.forEach(line => {
    const deClutteredLine = cleanLine(line);
    if (deClutteredLine.length >= MINIMUM_WORD_LENGTH) {
      skills.push(...extractFromLine(deClutteredLine));
    }
  });
  return skills;
};

/**
 * @param {string} experience
 */
export const extractSkillsFromExperienceField = experience => {
  if (!filterOutIgnoredPhrases(experience)) return [];
  const lines = experience.split('\n');
  return extractSkillsFromLines(lines);
};

export const formatDateTimeToDateString = dateTime => {
  if (!dateTime) return undefined;
  try {
    const [dateString] = dateTime.split(' ');

    return new Date(dateString).toISOString().slice(0, 10);
  } catch (error) {
    return undefined;
  }
};

export const createDataToSend = ({
  formData,
  candidate,
  user,
  schemaVersion,
  count,
  blueSheetId,
  dataSheetId: id
}) => {
  return {
    ...(id && { id }),
    candidate: {
      id: candidate.id,
      name: candidate.personalInformation.full_name,
      legacySheetId: blueSheetId
    },
    schema: {
      key: FormSchema.CandidateDataSheetFull,
      version: schemaVersion
    },
    progress: {
      current: count.answered,
      total: count.total
    },
    data: formData,
    trace: {
      user: {
        id: user.id,
        fullName: user.personalInformation.full_name,
        email: user.email,
        initials: getInitials(user.personalInformation.full_name)
      }
    }
  };
};
